import { type schemaType } from '~~/shared/api/rurality/v3/users/login/schema'
import { type paramsType } from '~~/shared/api/rurality/v3/users/login/paramsSchema'
import fetchUserIsLogged from '~~/modules/api/rurality/v3/user/is-logged'
import { useUserStore } from '~~/modules/auth/stores/userStore'

export type returnType = ApiServerResponse<schemaType>

export const serverFetch = async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/rurality/v3/users/login`

  const { data } = await useFetch(url, {
    body: { ...params },
    method: 'POST',
    key: url,
  })

  const result = data.value as returnType

  if (result.success) {
    const authUserIsLogged = await fetchUserIsLogged()
    const userStore = useUserStore()
    userStore.setUser(authUserIsLogged)
  }

  return result
}

export const browserFetch = async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/rurality/v3/users/login`

  const result = (await $fetch(url, {
    body: { ...params },
    method: 'POST',
  })) as returnType

  if (result.success) {
    const authUserIsLogged = await fetchUserIsLogged()
    const userStore = useUserStore()
    userStore.setUser(authUserIsLogged)
  }

  return result
}
